module.exports = __webpack_public_path__ + "img/Impact assessment-Alternative assessment.4852c54b.svg";